"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTextField = void 0;

var _styles = require("@mui/styles");

var _material = require("@mui/material");

var StyledTextField = (0, _styles.withStyles)(function () {
  return (0, _styles.createStyles)({
    root: {
      '& > .MuiFormHelperText-contained': {
        margin: 0,
        marginTop: 8
      }
    }
  });
})(_material.TextField);
exports.StyledTextField = StyledTextField;